<div class="col-sm-12 p-4">
    <div class=" m-0">
        <div class="container-fluid">
            <div class="row">
                <div>
                    <div class="row">
                        <div class="row col-12">
                            <div class="row col-12">
                                <h4 class="text-center p-2"> <b>{{'Reasons' | translate}}</b></h4>
                                <div class="card">
                                    <div class="row">
                                        <div class="col-12">
                                            <!-- <button class="btn btn-secondary m-2"
                                                *ngIf="caseObject!=null   &&(caseObject.violationStageId==4 || caseObject.violationStageId==7 || caseObject.violationStageId==8) && (sharedService.hasPermission('P501') || sharedService.hasPermission('P503') || sharedService.hasPermission('P504')) "
                                                (click)="addReason(AddReason)" href="javascript:void(0);">
                                                <i class="fa fa-plus-circle"></i>
                                                <span> {{ "InsertReason" | translate }} </span>
                                            </button> -->
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <table class="table table-striped mt-3">
                                            <thead class="thead-dark">
                                                <tr>
                                                    <th scope="col">{{"NumberReason" | translate }} </th>
                                                    <th scope="col"> {{"Description" | translate }} </th>
                                                    <!-- <th scope="col"> {{"Edit" | translate }}</th> -->
                                                    <!-- <th scope="col"> {{"Delete" | translate }}</th> -->
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let reason of caseReasonList">
                                                    <td>{{ reason.caseReasonId }}</td>
                                                    <td>{{ reason.description }}</td>
                                                    <!-- <td>
                                                        <a (click)="UpdateReason(reason, eidtreasonmodal)"
                                                            href="javascript:void(0);">

                                                            <i class="fa fa-edit"></i></a>
                                                    </td>
                                                    <td>
                                                        <a (click)="DeleteReason(reason.caseReasonId, delmodal)"
                                                            href="javascript:void(0);">
                                                            <i class="fa fa-trash"></i></a>
                                                    </td> -->

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<ng-template #eidtreasonmodal let-modal>
    <div class="TransApp">

        <div class="modal-header">
            <h2 class="fs-5 mb-0 text-secondary">
                {{'Edit' | translate}} {{'Reason' | translate}}
            </h2>
        </div>
        <div class="modal-body text-center py-2 px-3">

            <div class="form-group row">
                <div class="col-1">
                    <label for="CaseTitle">{{"AlReason" | translate }} </label>

                </div>

                <div class="col-9">
                    <ng-select class="form-control-select" [items]="reasons" bindLabel="title" bindValue="reasonId"
                        (change)="reasonSelectedEdit($event)" [(ngModel)]="reasonIdEdit"
                        [ngModelOptions]="{standalone: true}" placeholder="{{'Reasons'|translate}}">
                    </ng-select>

                </div>


            </div>
            <br />
            <div class="form-group row">
                <div class="col-12">
                    <textarea [(ngModel)]="descriptionReasonEdit" style="height:250px;" class="form-control"></textarea>
                </div>

            </div>



        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" (click)="onUpdateReason()">
                {{ "Save" | translate }}
            </button>
            <button type="button" class="btn btn-dark" (click)="modal.dismiss('Cross click')">
                {{ "cancel" | translate }}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #AddReason let-modal>
    <div class="TransApp">

        <div class="modal-header">
            <h2 class="fs-5 mb-0 text-secondary">
                {{ "InsertReason" | translate }}
            </h2>
        </div>
        <div class="modal-body text-center py-2 px-3">

            <div class="form-group row">
                <div class="col-1">
                    <label for="CaseTitle">{{"AlReason" | translate }} </label>

                </div>

                <div class="col-9">
                    <ng-select class="form-control-select" [items]="reasons" bindLabel="title" bindValue="description"
                        (change)="reasonSelected($event)" [(ngModel)]="reason" [ngModelOptions]="{standalone: true}"
                        placeholder="{{'Reasons'|translate}}">
                    </ng-select>

                </div>


            </div>
            <br />
            <div class="form-group row">
                <div class="col-12">
                    <textarea [(ngModel)]="caseresons" style="height:250px;" class="form-control"></textarea>
                </div>

            </div>



        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" (click)="onAddReason()">
                {{ "Save" | translate }}
            </button>
            <button type="button" class="btn btn-dark" data-bs-dismiss="modal" (click)="clear()">
                {{ "cancel" | translate }}
            </button>
        </div>
    </div>
</ng-template>


<ng-template #delmodal let-modal>
    <div class="modal-header" style="justify-content: center">
        <h2 class="modal-title fs-5 text-secondary" id="modal-basic-title">
            {{ "ConfirmDeleteOperation" | translate }}
        </h2>
    </div>
    <div class="modal-body text-center py-2 px-3">
        <p>{{ "SelectedRecordwillbeDeleted" | translate }}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="onDeleteReason()">
            {{ "YES" | translate }}
        </button>
        <button type="button" class="btn btn-dark" (click)="modal.dismiss('Cross click')">
            {{ "NO" | translate }}
        </button>
    </div>
</ng-template>
